import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { DropzoneModule } from '../directives/dropzone/dropzone.module';
import { NgxJsonViewerModule } from 'ngx-json-viewer';
import { DisclaimerComponent } from './disclaimer.component';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { ColorPickerModule } from 'ngx-color-picker';
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';
import { DisclaimerGenerationModule } from './disclaimer-generator/disclaimer-generator.module';

@NgModule({
  declarations: [DisclaimerComponent],
  imports: [
    CommonModule,
    FormsModule,
    DropzoneModule,
    NgxJsonViewerModule,
    ColorPickerModule,
    TooltipModule,
    DisclaimerGenerationModule,
    NgMultiSelectDropDownModule.forRoot(),
  ],
  exports: [DisclaimerComponent],
})
export class DisclaimerModule {}
